<script>
export const BS_EVENTS = ['show', 'shown', 'hide', 'hidden'];
</script>

<script setup>
import $ from 'jquery';

import { ref, toRef, computed, onMounted, onBeforeUnmount } from 'vue';

import DsIconButton from 'JIX/components/ds/DsIconButton.vue';
import { useBootstrapEvents } from 'JIX/bootstrapEvents.js';

import 'icons/options-menu--filled.svg';

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    menuLabel: {
        type: String,
        required: false,
        default: 'Menu',
    },
    items: {
        type: Array,
        required: true,
        default: () => [],
    },
    options: {
        type: Object,
        required: false,
        default: () => {},
    },
    buttonType: {
        type: String,
        default: 'secondary',
    },
    size: {
        type: String,
        default: 'md',
    },
});
const emit = defineEmits(BS_EVENTS);

const id = toRef(props, 'id');
const buttonId = computed(() => `${id.value}__button`);

const container = ref();
const button = ref();

useBootstrapEvents(container, emit, BS_EVENTS, { eventSuffix: '.bs.dropdown' });

onMounted(() => $(button.value.$el).dropdown(props.options));
onBeforeUnmount(() => $(button.value.$el).dropdown('dispose'));

const methods = {};
for (const name of ['show', 'hide', 'toggle', 'update']) {
    methods[name] = () => $(button.value.$el).modal(name);
}

defineExpose({
    ...methods,
});
</script>

<template>
    <div class="jix-options-menu dropdown" ref="container">
        <DsIconButton
            :type="buttonType"
            :size="size"
            :id="buttonId"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :label="menuLabel"
            ref="button"
            icon-name="options-menu--filled"
        />
        <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="buttonId">
            <Component
                :href="item.url"
                v-on="item.onclick ? { click: item.onclick } : {}"
                v-for="item in items"
                :key="item.key || item.label"
                :class="['dropdown-item', { active: item.active, 'text-danger': item.danger }]"
                :is="item.url ? 'a' : 'button'"
                @click="methods.hide()"
                :target="item.target"
            >
                {{ item.label }}
            </Component>
        </div>
    </div>
</template>
